export default "__VITE_PUBLIC_ASSET__eb0569f5__"